import './Heading.css';
import { ReactNode } from 'react';

interface HeadingProps {
	left: ReactNode;
	right?: ReactNode;
}

const Heading = ({ left, right }: HeadingProps) => {
	return (
		<div className='heading'>
			<div className='heading__columns'>
				<div className='heading__left'>
					<div className='heading__left-content'>{left}</div>
				</div>
				{right != null && <div className='heading__right'>{right}</div>}
			</div>
		</div>
	);
};

export { Heading };
